import type { ConsentKey } from "@/types/database/consents";
import Arthrosamid from "./arthrosamid/Arthrosamid";
import ArthrosamidCitius from "./arthrosamid/ArthrosamidCitius";
import ArthrosamidFortius from "./arthrosamid/ArthrosamidFortius";

const ConsentSwitch = ({ consentKey }: { consentKey: ConsentKey }) => {
	switch (consentKey) {
		case "ARTHROSAMID":
			return <Arthrosamid />;
		case "ARTHROSAMID_FORTIUS":
			return <ArthrosamidFortius />;
		case "ARTHROSAMID_CITIUS":
			return <ArthrosamidCitius />;
		default:
			return null;
	}
};

export default ConsentSwitch;
